import _ from 'lodash'
import RenderData from '../../RenderData'
import Render from './render/render'
import ChildRender from './render/childRender'
import Editor from './editor/editor'
import ChildEditor from './editor/childEditor'
import mainProps, { childProps } from './propsTemplate'
import RenderMode from './RenderMode'
import i18n from '@/i18n'

const name = 'PhotoWall'
const childName = name + 'Item'

const toolbarItems = [
  {
    tag: name,
    icon: 'icon-photo-wall',
    get label () {
      return i18n.t('microSite.photoWall.photoWallName')
    },
    isShow: true,
    staticProps: {
      renderMode: RenderMode.normal
    }
  },
  {
    tag: name,
    icon: 'icon-logo-wall',
    get label () {
      return i18n.t('microSite.photoWall.logoWallName')
    },
    isShow: false,
    staticProps: {
      renderMode: RenderMode.logo
    }
  },
  {
    tag: name,
    icon: 'icon-brand-wall',
    get label () {
      return i18n.t('microSite.photoWall.brandWallName')
    },
    isShow: false,
    staticProps: {
      renderMode: RenderMode.brand
    }
  }
]

const renders = {
  [name]: Render,
  [childName]: ChildRender
}

const editors = {
  [name]: Editor,
  [childName]: ChildEditor
}

function getEditorTitle (renderData) {
  if (renderData.tag === name) {
    const renderMode = renderData.data.props.renderMode
    switch (renderMode) {
      case RenderMode.brand:
        return i18n.t('microSite.photoWall.brandWallName')
      case RenderMode.logo:
        return i18n.t('microSite.photoWall.logoWallName')
      case RenderMode.normal:
        return i18n.t('microSite.photoWall.photoWallName')
    }
  } else if (renderData.tag === childName) {
    const renderMode = renderData.parent.data.props.renderMode
    switch (renderMode) {
      case RenderMode.brand:
        return i18n.t('microSite.photoWall.brandImg')
      case RenderMode.logo:
        return i18n.t('microSite.photoWall.logo')
      case RenderMode.normal:
        return i18n.t('microSite.photoWall.img')
    }
  }
}

function createRenderData (tag, index, parent) {
  if (!renders.hasOwnProperty(tag)) {
    return
  }
  const data = {
    props: _.cloneDeep(mainProps)
  }
  const renderData = new RenderData(tag, data, -1, index, parent, [])
  return renderData
}

function createChildRenderData (parent) {
  const parentTag = parent.tag
  if (parentTag !== name) {
    return
  }
  const index = parent.children.length
  const data = {
    props: _.cloneDeep(childProps)
  }
  data.props.renderMode = parent.data.props.renderMode
  const renderData = new RenderData(childName, data, -1, index, parent)
  return renderData
}

const module = {
  name,
  toolbarItems,
  renders,
  editors,
  getEditorTitle,
  createRenderData,
  createChildRenderData
}

const suggestionUploadSize = {
  pc: {
    [RenderMode.normal]: '240*200'
  },

  mobile: {

  }
}

export default module

export { childName, suggestionUploadSize }
